












import { Component, Prop, Vue } from "vue-property-decorator";

import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {
  }
})
export default class CloudSinginBalloon extends Vue {

    signin(){
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$store.dispatch("setCloudMode", "open");
        this.$store.dispatch("setSignInToGo", "");
        this.$router.push("/signIn");
    }

    signup(){
        this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
        this.$store.dispatch("setCloudMode", "open");
        this.$store.dispatch("setSignInToGo", "");
        this.$router.push("/UserRegistration");
    }

    close() {
        this.$emit("close");
    }

    private get message(){
        return "ユーザ登録を行うと下記の機能がご利用いただけます。\n"
        + "<b>・ラベル屋さん&#8482;ソフト クラウドストレージサービス</b>\n"
        + "<b>・各社クラウドストレージサービス連携機能</b>\n"
        + "詳しくはラベル屋さん&#8482;ソフトのWebサイトをご確認ください。\n"
        + "<a href='https://www.labelyasan.com/guide/#feature05' target='_blank'>URL:https://www.labelyasan.com/guide/#feature05</a>"
    }
  
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigButtonColor(){
        return {
            background: this.userConfigColor
        };
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}
